import Stack from '@mui/material/Stack';
import LastSyncCard from '../LastSyncCard';
import SyncedCard from '../SyncedCard';
import UnsyncedCard from '../UnsyncedCard';
import { ContainerSx } from './styles';
import { JamfStatsCardGroupProps } from './types';

const JamfStatsCardGroup = (props: JamfStatsCardGroupProps) => {
  const {
    'data-testid': dataTestId,
    lastSyncDate,
    syncedCount,
    unsyncedCount,
    learnMoreUrl,
    processing
  } = props;

  return (
    <Stack
      sx={ContainerSx}
      data-testid={dataTestId}
    >
      <LastSyncCard
        data-testid={`${dataTestId}-last-sync`}
        lastSyncDate={lastSyncDate}
        processing={processing}
      />
      <SyncedCard
        data-testid={`${dataTestId}-synced`}
        syncedCount={syncedCount}
        processing={processing}
      />
      <UnsyncedCard
        data-testid={`${dataTestId}-unsynced`}
        unsyncedCount={unsyncedCount}
        learnMoreUrl={learnMoreUrl}
        processing={processing}
      />
    </Stack>
  );
};

export default JamfStatsCardGroup; 
